// extracted by mini-css-extract-plugin
export default {"description-text":"_34v791ka4AxDew6PzAPPOY","form-row":"_2TBhfF_9pC9eMDCS-UO5Zq","save-account-mapping-conatiner":"gzG0hS8oz9WuPcgN-OLvC","loader":"_1yC8jbCnVjgDyYhpjlUmav"};